var _defs, _path, _circle, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMod2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 898.24 724.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#2731b8;stroke-miterlimit:10;stroke-width:20px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M294.56,873.58c-20.43-191.17,106.36-331.85,209.69-334.7C610,536,748.09,675.69,730,873.58Z",
    transform: "translate(-62.75 -159.45)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 445.09,
    cy: 217.93,
    r: 161.45
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M292.08,827.1H74.94C54.5,635.93,181.29,495.25,284.62,492.39c66.62-1.84,123.67,53.2,142,71.48",
    transform: "translate(-62.75 -159.45)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M373.89,467.76c-9.95,6.29-42.33,26.16-85.68,24.59-71.48-2.59-161.44-63.05-161.44-161.45A161.44,161.44,0,0,1,288.21,169.46c52.52,0,103.25,27.18,132.89,69.74",
    transform: "translate(-62.75 -159.45)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M591.51,565.16c18.47-19.32,70.16-73.36,132.36-72.77,96.52.93,200.3,133.24,225.78,334.71H732.32",
    transform: "translate(-62.75 -159.45)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M595.19,241.36c2.85-4.1,52.16-72.55,132.27-71.9,78.28.63,161.45,67,161.45,161.44A161.45,161.45,0,0,1,727.46,492.35c-44.07,0-76.89-18.93-86.46-25.08",
    transform: "translate(-62.75 -159.45)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMod2);
export default __webpack_public_path__ + "static/media/Mod2.fd3edf710800b9bd926ea1161f5e7e2c.svg";
export { ForwardRef as ReactComponent };